import { render, staticRenderFns } from "./coach-signup.vue?vue&type=template&id=2c1dd63c&lang=pug&"
import script from "./coach-signup.vue?vue&type=script&lang=js&"
export * from "./coach-signup.vue?vue&type=script&lang=js&"
import style0 from "./coach-signup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports